"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHA3_512 = void 0;
const js_sha3_1 = require("js-sha3");
const HashFunction_1 = require("./HashFunction");
const HashingType_1 = require("./HashingType");
class SHA3_512 extends HashFunction_1.HashFunction {
    constructor() {
        super(HashingType_1.HashingType.Type.sha3_512);
    }
    hashing(data) {
        return js_sha3_1.sha3_512.update(data).hex();
    }
}
exports.SHA3_512 = SHA3_512;
//# sourceMappingURL=sha3_512.js.map